import { useI18n } from "@/lib/i18n";

export default function HowItWorks() {
  const { t } = useI18n();

  return (
    <section className="py-16 lg:py-20 border-t border-border">
      <div className="mx-auto max-w-container px-6 lg:px-10">
        <div className="max-w-prose mb-10 reveal">
          <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-3">
            {t.home.howEyebrow}
          </div>
          <h2 className="font-serif text-[36px] lg:text-[44px] leading-[1.1] tracking-tight">
            {t.home.howTitle}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-8">
          {t.home.steps.map(([n, title, body], i) => (
            <div key={n} className="reveal pt-5 border-t border-border" style={{ transitionDelay: `${i * 70}ms` }}>
              <div className="font-serif text-3xl text-primary">{n}</div>
              <h3 className="font-serif text-xl mt-3 mb-2">{title}</h3>
              <p className="text-[15px] text-muted-foreground leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
